import React, { useState } from 'react'
import { MdDragIndicator } from 'react-icons/md';

const ReorderProducts = () => {
  const [activeTab, setActiveTab] = useState('web');

  const tabs = [
    { id: 'web', label: 'Web App View' },
    { id: 'mobile', label: 'Mobile App View', disabled: true },
  ];

  const renderTabs = () => (
    <div className="flex border-b gap-3 border-[#b9ece6]">
      {tabs.map((tab) => (
        <button
          key={tab.id}
          className={`px-4 py-2 font-medium text-sm transition-colors duration-200 rounded-t-md ${activeTab === tab.id
              ? 'border-b-2 border-[#1a9588] bg-[#1a9588] text-white'
              : 'text-gray-500 bg-[#dbf4f1]'
            } ${tab.disabled ? 'opacity-50 cursor-not-allowed' : 'hover:text-gray-700 hover:bg-[#b9ece6]'}`}
          onClick={() => !tab.disabled && setActiveTab(tab.id)}
          disabled={tab.disabled}
        >
          {tab.label}
        </button>
      ))}
    </div>
  );
  return (
    <div id="top">
      <div className="text-start">

        <div className="flex items-center gap-4 mb-8">
          <MdDragIndicator className="text-pink-600 text-5xl" />
          <h1 className="text-3xl sm:text-4xl font-bold text-gray-900">Reorder Products</h1>
        </div>
      </div>

      <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center mb-6 sm:mb-8 gap-4">
        <div className="flex flex-wrap gap-2">
          <span className="bg-pink-600 text-white px-3 py-1 rounded-lg font-semibold text-xs md:text-sm sm:text-sm">
            Seller
          </span>
          <span className="bg-yellow-100 text-yellow-300 px-3 py-1 rounded-lg font-semibold text-xs md:text-sm sm:text-sm">
            Buyer
          </span>
        </div>
        <div className="flex flex-wrap gap-2">
          <span className="bg-blue-100 text-blue-600 px-3 py-1 rounded-lg font-semibold text-xs md:text-sm sm:text-sm">
            Web
          </span>
 
          <span className="bg-green-100 text-green-300 px-3 py-1 rounded-lg font-semibold text-xs md:text-sm sm:text-sm">
            Android
          </span>
        </div>
      </div>

      <hr />

      <div className="flex flex-col md:flex-row gap-8 scroll-smooth">
        <div className="md:w-3/4 lg:w-3/4 w-full p-4 text-start">
          <div id="start-setup" className="scroll-mt-20">
            <p className="text-gray-600 mb-6">
              Once the products have been categorised, they can further be reordered within that category. Go to the 'Category' section and click the button 'Reorder Products', to open the reordering overlay. Simply drag the products in the order you wish and click 'Save Product Order'. Your products now display in the order as set by you.
            </p>
            {renderTabs()}
            <div className="mt-4 p-4 border border-gray-200 rounded-lg">
              {activeTab === 'web' && (
                <img
                  src=""
                  alt="Web App View of Seller Setup"
                  className="w-full h-auto"
                />
              )}
              {activeTab === 'mobile' && (
                <div className="text-center text-gray-500">Mobile App View is disabled for this section.</div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ReorderProducts